// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3CmbS","rightAdornment":"Header_rightAdornment__UBi0-"};